import React from "react";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "Shanur turned around three complex SMSF SOAs in a week, and they were cleaner than what I was producing in house. He's now the first call for every new client engagement.",
    name: "Daniel M.",
    role: "Senior Financial Adviser",
    firm: "Melbourne, VIC",
  },
  {
    quote:
      "The compliance discipline is exceptional. We've put dozens of SOAs through our licensee review and the rework rate is genuinely close to zero. It's a different category of paraplanning.",
    name: "Priya K.",
    role: "Practice Principal",
    firm: "Sydney, NSW",
  },
  {
    quote:
      "He rebuilt our review workflow in Excel VBA and gave us back six hours per file. The automation work alone paid for the engagement in the first month.",
    name: "James R.",
    role: "Director, AFSL-Licensed Practice",
    firm: "Brisbane, QLD",
  },
  {
    quote:
      "Plain-English client copy that I don't have to rewrite. Modeling I can defend in a meeting. SLAs that actually hold. That's the whole pitch.",
    name: "Amanda T.",
    role: "Financial Adviser, CFP®",
    firm: "Perth, WA",
  },
  {
    quote:
      "Onboarding took two calls. He learned our licensee template faster than any paraplanner I've worked with. Quality is consistent file after file.",
    name: "Mark D.",
    role: "Senior Adviser",
    firm: "Adelaide, SA",
  },
];

const Card = ({ t }) => (
  <figure
    data-testid={`testimonial-${t.name.split(' ')[0].toLowerCase()}`}
    className="shrink-0 w-[300px] md:w-[380px] bg-white text-black border-2 border-black p-6 md:p-8 shadow-brutal-yellow mx-3 md:mx-4"
  >
    <Quote className="w-8 h-8 text-[#FACC15] mb-3" strokeWidth={3} />
    <div className="flex items-center gap-1 mb-3" aria-label="5 out of 5 stars">
      {[0, 1, 2, 3, 4].map((i) => (
        <Star key={i} className="w-4 h-4 fill-[#FACC15] text-[#FACC15]" />
      ))}
    </div>
    <blockquote className="text-sm md:text-base leading-relaxed">&ldquo;{t.quote}&rdquo;</blockquote>
    <figcaption className="mt-5 pt-4 border-t-2 border-black">
      <p className="font-display font-bold text-base leading-none">{t.name}</p>
      <p className="text-xs text-black/70 mt-1">
        {t.role} · {t.firm}
      </p>
    </figcaption>
  </figure>
);

const Testimonials = () => {
  const loop = [...testimonials, ...testimonials];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-black text-white border-b-2 border-black overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-block bg-[#FACC15] border-2 border-[#FACC15] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest">
              Advisor Voices
            </span>
            <h2 className="font-display font-black mt-4 text-4xl md:text-5xl tracking-tighter leading-[1.05]">
              Trusted by advisers from Perth to Sydney.
            </h2>
          </div>
          <p className="text-sm md:text-base text-white/70 max-w-md">
            Real feedback from licensed Australian advisers who&apos;ve handed Banana Paraplanner the keys
            to their SOA workflow.
          </p>
        </div>
      </div>

      <div className="pb-20 md:pb-28 [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]">
        <div className="marquee">
          {loop.map((t, i) => (
            <Card key={`${t.name}-${i}`} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
